// extracted by mini-css-extract-plugin
export default {"container":"CampaignTabs_container__hzDMW"};